export default __webpack_public_path__ + "static/media/speeding.87577453.svg";